import { useQueries, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ARCHIVE_BANNER_SUMMARY_QUERY_KEY, canFetchArchiveBannerSummary, fetchArchiveBannerSummary, getArchiveBannerSiteId, getArchiveBannerSiteIds, mergeArchiveBannerSummaries, } from '../../helpers/archive_banner.helpers';
export const useArchiveBannerSummary = ({ environment, siteId, enabled }) => {
    const resolvedSiteId = getArchiveBannerSiteId(environment, siteId);
    return useQuery({
        queryKey: [ARCHIVE_BANNER_SUMMARY_QUERY_KEY, environment?.id, resolvedSiteId],
        queryFn: () => fetchArchiveBannerSummary(environment, resolvedSiteId),
        enabled: enabled && canFetchArchiveBannerSummary(environment, resolvedSiteId),
    });
};
export const useArchiveBannerSummaries = (environments, enabled) => {
    const targets = useMemo(() => environments.flatMap((environment) => getArchiveBannerSiteIds(environment).map((siteId) => ({ environment, siteId }))), [environments]);
    const queries = useQueries({
        queries: targets.map(({ environment, siteId }) => ({
            queryKey: [ARCHIVE_BANNER_SUMMARY_QUERY_KEY, environment.id, siteId],
            queryFn: () => fetchArchiveBannerSummary(environment, siteId),
            enabled: enabled && canFetchArchiveBannerSummary(environment, siteId),
        })),
    });
    return useMemo(() => {
        const summaries = new Map();
        targets.forEach((target, index) => {
            const merged = mergeArchiveBannerSummaries([summaries.get(target.environment.id), queries[index]?.data]);
            if (merged) {
                summaries.set(target.environment.id, merged);
            }
            else {
                summaries.delete(target.environment.id);
            }
        });
        return summaries;
    }, [targets, queries]);
};
